/**
 * Knowledge Banks — the portal tab that embeds the hosted KB Explorer.
 *
 * The explorer itself is the gurucloud-kb SDK's UI, served by the api at
 * /kb-explorer/ (app/routes/kb_explorer.py): bank picker, entries, cluster
 * map, playbooks, schema, quality, history, connect. It is a same-origin page
 * with its own routing (?kb=… and #tab), so the portal simply frames it
 * edge-to-edge below the navbar (PortalLayout gives this route the full-bleed
 * layout). Auth rides the cm_auth cookie the SPA set at login; the api gates
 * the framed page and its API on the kb:explore grant (admins pass), the same
 * rule KbExploreRoute applies to this tab.
 */

import styles from './PortalKnowledgeBanksPage.module.css';

/** Where the api hosts the explorer. Trailing slash matters: the bundle's
 *  asset paths are relative to the page URL. */
export const KB_EXPLORER_PATH = '/kb-explorer/';

export default function PortalKnowledgeBanksPage() {
  return (
    <div className={styles.page} data-testid="portal-knowledge-banks">
      <iframe
        className={styles.frame}
        src={KB_EXPLORER_PATH}
        title="Knowledge Bank Explorer"
        // Same-origin page: no sandbox — the explorer needs its own storage
        // (picker preferences) and same-origin fetches with the session cookie.
        allow="clipboard-write"
      />
    </div>
  );
}
